/* src/app/admin/admin.component.scss */
.error {
  background-color: #fce6e2;
}
.success {
  background-color: #e4f6dc;
}
/*# sourceMappingURL=admin.component.css.map */
